<template>
  <div class="sign">
    <div class="sign_head">
      <img class="sign_back" src="../../assets/images/sign/icon-back.png" alt=""
           @click="$router.replace(`/signclazz?outId=${outId}&clazzId=${clazzId}`)">学生签字
      <div></div>
    </div>
    <div class="sign_panel">
      <div class="sign_panel-head">
        <div>
          <img class="sign_icon" src="../../assets/images/sign/icon-bj.png" alt="">
          {{clazzName}}
          <span class="sign_panel-head-subtitle">共{{studentNames.length}}名学员</span>
        </div>
      </div>
      <div class="sign_panel-body">
        <div class="sign_item">
          <span class="sign_item-label">品目名称：</span>
          <span class="sign_item-val">{{outputDetail.itemName}}</span>
        </div>
        <div class="sign_item">
          <span class="sign_item-label">领用日期：</span>
          <span class="sign_item-val">{{outDate}}</span>
        </div>
      </div>
    </div>
    <div class="sign_panel">
      <div class="sign_panel-head">
        <div>
          <img class="sign_icon" src="../../assets/images/sign/icon-lyry.png" alt="">
          领用人员
        </div>
        <span class="sign_panel-head-subtitle">数量：{{outputDetail.no}}</span>
      </div>
      <div class="sign_panel-body sign_lyry">
        <div class="sign_item" v-for="(item,index) in studentNames" v-show="index<8 || showMore">
          <span>{{item}}</span>
        </div>

        <div class="sign_item sign_zkqb" v-if="studentNames.length>7 && showMore" @click="showMore=false">
          <img style="transform: rotate(180deg)" class="sign_icon" src="../../assets/images/sign/icon-zkgd.png" alt="">收起
        </div>
        <div class="sign_item sign_zkqb" v-if="studentNames.length>7 && !showMore" @click="showMore=true">
          <img style="margin-top: 0" class="sign_icon" src="../../assets/images/sign/icon-zkgd.png" alt="">展开全部
        </div>
      </div>
    </div>
    <div class="sign_panel">
      <div class="sign_panel-head">
        <div>
          <img class="sign_icon" src="../../assets/images/sign/icon-qm.png" alt="">
          签名
        </div>
      </div>
      <div class="sign_panel-body">
        <div class="qm" @click="gotoSign">
          <template v-if="!url">
            <img src="../../assets/images/sign/bg-qm.png" class="placeholeder" ref="pImg" alt="">
            <span>点击进入签名</span>
          </template>
          <img :src="url" v-else alt="" class="signimg" ref="signImg">
        </div>
        <div class="sign_item">
          <span class="sign_item-label">职务：</span>
          <div>
            <div @click="toggleRoleListVisible">{{role||'请选择'}}</div>
          </div>
        </div>
        <div class="sign_item">
          <span class="sign_item-label">电话：</span>
          <div>
            <input type="text" placeholder="请输入11位手机号" :readonly="isSigned" v-model="phone">
          </div>
        </div>
      </div>
    </div>

    <button class="confirm" type="button" v-if="!isSigned" @click="submit">确定</button>

    <div class="select" v-show="roleListVisible">
      <div class="select_body">
        <ul class="select_body-options">
          <li :class="['select_body-option',{selected:item===tempRole}]" v-for="item in roleList"
              @click="changeTempRole(item)">{{item}}
          </li>
        </ul>
        <div class="select_foot">
          <button type="button" @click="changeRole(true)">取消</button>
          <button type="button" class="select_confirm" @click="changeRole(false)">确定</button>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
  import './flexible'
  import axios from 'axios'
  import Toast from './toast.js'

  export default {
    name: 'StudentList',
    data() {
      return {
        roleList: ['无职务', '教师', '班长', '学习委员', '体育委员'],
        roleListVisible: false,
        studentNames: [],
        outputDetail: {},
        clazzName: '',
        outDate: '',
        showMore: false,
        role: null,
        tempRole: null,
        phone: null,
        url: null,
        orderId: null,
        outId: null,
        isSubmit: false,
        isSigned: false,
        needClear: false
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        if (from.name === 'Sign') {
          vm.url = vm.$route.params.url
          vm.needClear = false
        } else {
          vm.studentNames = vm.$route.params.studentNames || []
          vm.outputDetail = vm.$route.params.outputDetail || {}
          vm.clazzName = vm.$route.params.clazzName
          vm.clazzId = vm.$route.params.clazzId
          vm.orderId = vm.$route.params.orderId
          vm.outId = vm.$route.params.outId
          vm.outDate = vm.$route.params.outDate
          vm.isSigned = vm.$route.params.isSigned

          vm.role = vm.$route.params.signRole
          vm.phone = vm.$route.params.signPhone
          vm.url = vm.$route.params.url
          vm.needClear = true
        }

      })
    },

    methods: {
      toggleRoleListVisible() {
        if (this.isSigned) return;
        this.roleListVisible = !this.roleListVisible
      },
      submit() {
        if (!this.url) {
          Toast('请签名')
          return;
        }
        if (!this.role) {
          Toast('请选择职务')
          return;
        }
        if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(this.phone)) {
          Toast('请输入正确的手机号码')
          return;
        }
        if (this.isSubmit) return;
        this.isSubmit = true
        axios.post(`${process.env.SIGN_API_ROOT}/ims/storage-output/sign/add`, {
          signType: 1,
          orderId: this.orderId,
          clazzId: this.clazzId,
          businessId: this.outId,
          signRole: this.role,
          signPhone: this.phone,
          signUrl: this.url
        }).then(res => {
          this.isSubmit = false
          if (res.data.errCode !== '00') {
            Toast(res.data.errMsg)
          } else {
            this.$router.push({
              name: 'SignClazz',
              query: {outId: this.outId, clazzId: this.clazzId, signed: 'signed', role: this.role, phone: this.phone},
              params: {url: this.url}
            })
          }

        }, err => {
          Toast('出错了')
        })
      },
      changeTempRole(role) {
        this.tempRole = role
      },
      changeRole(isCancel) {
        if (isCancel) {
          this.tempRole = this.role
        } else {
          this.role = this.tempRole
        }

        this.toggleRoleListVisible()
      },
      gotoSign() {
        if (this.isSigned) return;
        this.$router.push({name: 'Sign', params: {url: this.url, needClear: this.needClear}})
      }
    }
  }
</script>
<style scoped>
  .sign {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
  }

  .sign_icon {
    width: .32rem;
    margin-top: -.05rem;
    margin-right: .13rem;
  }

  .sign_back {
    width: .5rem;
  }

  .sign_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.3rem;
    height: 1rem;
    line-height: 1rem;
    background: #ffffff;
    text-align: center;
    font-size: 0.4rem;
    border-bottom: .013rem solid #c7c7c7;
  }

  .sign_panel-head-subtitle {
    color: #666666;
    font-size: .34rem;
  }

  .sign_panel {
    margin: .26rem auto .4rem;
    /*padding: .13rem .4rem;*/
    width: 92%;
    border-radius: .125rem;
    background: #ffffff;
    box-sizing: border-box;
    color: #666666;
    font-size: .34rem;
  }

  .sign_panel-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.08rem;
    line-height: 1.08rem;
    border-bottom: .013rem solid #f6f6f6;
    font-size: .37rem;
    color: #333333;
    padding: 0 0.4rem;
  }

  .sign_panel-body {
    padding: 0 0.4rem;
  }

  .sign_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: .88rem;
  }

  .sign_item-label {
    font-size: .34rem;
    color: #666666;
  }

  .sign_item-val {
    font-size: .4rem;
    color: #333333;
  }

  .sign_lyry .sign_item {
    color: #333333;
    height: .96rem;
    border-bottom: .013rem solid #f6f6f6;
  }

  .sign_lyry .sign_item:last-child {
    border-bottom: none;
  }

  .sign_lyry .sign_zkqb {
    justify-content: center;
    color: #999999;
    font-size: .32rem;
  }

  input, select {
    font-size: .32rem;
    text-align: right;
  }

  .select {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .select_body {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 6.72rem;
    background: #ffffff;
  }

  .select_body-options {
    width: 50%;
    margin: .53rem auto;
  }

  .select_body-option {
    font-size: .37rem;
    color: #333333;
    border-bottom: .013rem solid #f6f6f6;
    height: .92rem;
    line-height: .92rem;
    text-align: center;
  }

  .select_body-options .select_body-option:last-child {
    border-bottom: none;
  }

  .select_body-options .select_body-option.selected {
    color: #0D80FE;
  }

  .select_foot {
    display: flex;
  }

  .select_foot button {
    display: block;
    width: 50%;
    height: 1.06rem;
    border: none;
    background: #ffffff;
    font-size: .37rem;
    border-top: .013rem solid #f6f6f6;
  }

  .select_foot button.select_confirm {
    background: #0D80FE;
    color: #ffffff;
  }

  .qm {
    position: relative;
    width: 100%;
    height: 4.72rem;
    line-height: 4.72rem;
    color: #0D80FE;
    font-size: .42rem;
    margin-bottom: .26rem;
    text-align: center;
  }

  .qm img.placeholeder {
    width: 100%;
    height: 100%;
  }

  .qm img.signimg {
    height: 100%;
  }

  .qm span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .confirm {
    display: block;
    border: none;
    width: 5.46rem;
    height: .9rem;
    margin: .26rem auto .5rem;
    font-size: .4rem;
    border-radius: .45rem;
    background: #0D80FE;
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// Student.vue?95ff8978